// extracted by mini-css-extract-plugin
export default {"brandPromo":"VH-z","carousel":"WH-z"};